import React from 'react'
import createIcon from '@/lib/create-icon'

export const SuitcaseSVGIcon = createIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3327 17.5V4.16667C13.3327 3.72464 13.1571 3.30072 12.8445 2.98816C12.532 2.67559 12.108 2.5 11.666 2.5H8.33268C7.89066 2.5 7.46673 2.67559 7.15417 2.98816C6.84161 3.30072 6.66602 3.72464 6.66602 4.16667V17.5M3.33268 5.83333H16.666C17.5865 5.83333 18.3327 6.57953 18.3327 7.5V15.8333C18.3327 16.7538 17.5865 17.5 16.666 17.5H3.33268C2.41221 17.5 1.66602 16.7538 1.66602 15.8333V7.5C1.66602 6.57953 2.41221 5.83333 3.33268 5.83333Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
)
